// @core/api/endpoints/subscription/cancel_bundle_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Cancel bundle subscription
 * Cancels a tenant's bundle subscription. All included product subscriptions are also cancelled.
 */
export async function CancelBundleSubscription(
  subscription_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundle-subscriptions/:subscription_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
